{
  "title": "Id Insinuation (UA)",
  "source": "Unearthed Arcana 66 - Fighter, Rogue, and Wizard",
  "levelAndSchool": "1st-level enchantment",
  "level": 1,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You unleash a torrent of conflicting desires in the mind of one creature you can see within range, impairing its ability to make decisions. The target must succeed on a Wisdom saving throw or be incapacitated. At the end of each of its turns, it takes 1d12 psychic damage, and it can then make another Wisdom saving throw. On a success, the spell ends on the target."
  ],
  "spellLists": ["arcane-trickster", "sorcerer", "warlock", "wizard"]
}
